import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getWeekDayName from '@chama/utils/functions/get-week-day-name';
import getMonthName from '@chama/utils/functions/get-month-name';
import moment from 'moment';
import groupBy from 'lodash.groupby';
import values from 'lodash.values';
import keys from 'lodash.keys';
import calendarIcon from '@chama/statics/assets/svg/calendar-outlined.svg';
import isCsUser from '@chama/utils/functions/is-cs-user';
import getStatusIconSrc from './get-order-status-icon';
import getOrderStatusLabel from './get-order-status-label';
import './index.css';

const propTypes = {
  eventList: PropTypes.array.isRequired,
};

class EventHistory extends Component {
  renderEventListItems = list => {
    const eventsIntoListItems = ({ orderStatus, creationTime, actingUserId }) => {
      const isCs = isCsUser(actingUserId);
      const momentEventDate = moment(creationTime);
      const key = `${orderStatus}${creationTime}`;

      return (
        <li key={key} className="EventHistory__event">
          <div className="EventHistory__event_icon_time">
            <img
              className="EventHistory__event_icon"
              src={getStatusIconSrc(orderStatus, isCs)}
              alt="event icon"
            />
            <span className="EventHistory__event_time">
              <span>{momentEventDate.format('HH:mm')} </span>
              <span className="EventHistory__event_time_merediem">
                {momentEventDate.hours() > 12 ? 'pm' : 'am'}
              </span>
            </span>
          </div>

          <div className="EventHistory__event_info">
            <div>
              <strong>{getOrderStatusLabel(orderStatus, isCs)}</strong>
            </div>
            {actingUserId && <div className="EventHistory__event_actor">{actingUserId}</div>}
          </div>
        </li>
      );
    };

    return list.map(eventsIntoListItems);
  };

  render() {
    const { eventList } = this.props;
    const periods = groupBy(eventList, event => event.creationTime.split('T')[0]);
    const periodsTime = keys(periods);
    const periodsIntoEventLists = (periodEventList, i) => {
      const momentPeriodDate = moment(periodsTime[i]);
      const weekdayName = getWeekDayName(periodsTime[i]);
      const monthName = getMonthName(periodsTime[i]);

      return (
        <div key={periodsTime[i]} className="EventHistory__period">
          <div className="EventHistory__period_title">
            <img src={calendarIcon} alt="calendar" />
            <span className="EventHistory__period_title_text">
              <span className="u__capitalize">{weekdayName}, </span>
              <span>{momentPeriodDate.format('D')} de </span>
              <span className="u__capitalize">{monthName} </span>
              <span>{momentPeriodDate.format('YYYY')}</span>
            </span>
          </div>

          <ul className="EventHistory__event_list u__normalize_list">
            {this.renderEventListItems(periodEventList)}
          </ul>
        </div>
      );
    };

    return <div className="EventHistory">{values(periods).map(periodsIntoEventLists)}</div>;
  }
}

EventHistory.propTypes = propTypes;

export default EventHistory;



// WEBPACK FOOTER //
// ./src/modules/orders/components/OrderDetailsLayout/EventHistory/index.jsx